/**
 * The journey a journey-owned call is about (JOURNEYS-MULTI-ROUTE-PLAN · X6 ·
 * X7). The hooks that make such calls stay idle (`enabled: !!journeyId`) until
 * the journey is known, so this throws only on a call that names none — the
 * call that used to read or write across every journey the citizen holds.
 */
export function requireJourney(journeyId: string | null | undefined): string {
  if (!journeyId) throw new Error('This call names the journey it is about');
  return journeyId;
}
